export const screens = { sm: { max: '' } };
